<template>
  <div class="contact-us-page">
    <div class="top_bgm">
      <img :src="this.info.ico" alt="后端打野去了" />
      <div class="one">
        <img src="@assets/images/o1.png" alt="后端猥琐发育中" />
      </div>
      <div class="two">
        <img src="@assets/images/o0.png" alt="后端猥琐发育中" />
      </div>
    </div>
    <div class="main">
      <div class="main-top">
        <p class="title">
          {{ this.info.title }}
        </p>
        <span class="fl">{{ this.imgnumber }}张图片</span>
        <span class="fr">更新日期{{ this.info.date }}</span>
      </div>
      <div class="main-main" v-for="item in this.img" :key="item">
        <div class="img_hd fl">
          <img :src="item" alt="" />
        </div>
      </div>
      <div
        class="last_one"
        :class="this.img.length % 2 !== 0 ? 'active' : 'hidden'"
      >
        <!-- <img src="@assets/images/no_pic.png" alt="" /> -->
      </div>
      <!--  -->
      <div v-html="this.info.content" class="rich_text" id="rich_text"></div>
    </div>
  </div>
</template>

<script>
// import { actionDetail } from "@api/common";
import { example } from "@api/common";
import { baseInfo } from "@utils/config.js";

export default {
  data() {
    return {
      aid: "",
      info: {},
      img: [],
      title: "",
      time: "",
      banner: "",
      imgnumber: 0
    };
  },
  created() {
    this.getDataInfo();
    // console.log(this.videoSrc);
    console.log(this.$route.query.id);
  },
  methods: {
    getDataInfo() {
      example({ type: 3, content: this.$route.query.id }).then(res => {
        console.log("文字部分", res.data.data.content);
        this.info = res.data.data;
        // const str = res.data.data.content.split("img").length - 1;
        // console.log("图片数量", str);
        this.imgnumber = res.data.data.content.split("img").length - 1;
      });
    }
  },
  updated() {
    let obj = document.getElementById("rich_text");
    let imgs = obj.getElementsByTagName("img");
    let ps = obj.getElementsByTagName("p");
    console.log("obj", obj);
    console.log("imgs", imgs);
    for (let i = 0; i < imgs.length; i++) {
      imgs[i].style.width = "100%";
      imgs[i].style.height = "13.5em";
    }
    for (let i = 0; i < ps.length; i++) {
      ps[i].style.textIndent = "0";
    }
  },
  computed: {
    getWebSoketDomain() {
      return baseInfo.webSoketDomain;
    }
  }
};
</script>
<style lang="scss" scoped>
.contact-us-page {
  .top_bgm {
    width: 100%;
    height: 30%;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .one {
      // background-color: #aaf;
      width: 100%;
      height: 0.9rem;
      position: absolute;
      top: 0;
      left: 0;
    }
    .two {
      // background-color: #afa;
      width: 100%;
      height: 0.9rem;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
  .main {
    .main-top {
      display: block;
      padding-left: 20px;
      padding-right: 20px;
      padding-top: 20px;
      overflow: hidden;
      .title {
        display: block;
        font-weight: 700;
        font-size: 0.33rem;
        color: #000;
        line-height: 0.4rem;
        height: 1.25rem;
        overflow: hidden;
        margin-bottom: 0.1rem;
      }
      span {
        color: #999999;
        margin-bottom: 0.2rem;
      }
    }
    .main-main {
      padding: 0 0.3rem;
      // overflow: hidden;
      .img_hd {
        width: 100%;
        height: 3.7rem;
        overflow: hidden;
        margin-bottom: 0.3rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .last_one {
      width: 45%;
      height: 3rem;
      overflow: hidden;
      float: left;
      margin-top: 0.3rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .rich_text {
    padding: 0 10px;
    text-align: center;
    p {
      text-indent: 1em;
    }
  }
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.active {
  display: block;
}
.hidden {
  display: none;
}
</style>
